$(function () {
    var selectSeoCityId;
    var selectSeoPhotocenterId = 0;
    var citySysName = 0;

    const rules = {
        '/products/photoprint': '/products/view/photoprint',
        '/products/souvenirs': '/products/souvenirs',
        '/products/interior': '/products/interior',
        '/products/polygraphy': '/products/polygraphy',
        '/products/calendars': '/products/calendars',
        '/photobooks/groups/<groupId>':
            '/products/view/photobooks?groupId=<groupId>',
        '/products/photobooks': '/products/view/photobooks',
        '/interior/<url>': '/products/interior/view/<url>',
        '/souvenir/<url>': '/products/view/<url>',
        '/photobooks/types/<id>': '/products/photobooks/types/<id>',
    };

    $(document).on('click', '.js-set-pointer-seo-city', function () {
        selectSeoCityId = $(this).attr('data-id');

        $('.js-set-pointer-seo-city').removeClass('is-active');
        $(this).addClass('is-active');

        let selectCityId = $(this).data('city-id');
        if (selectCityId == '') {
            $('#seo-select-photocenter').addClass('is-hidden');
            return;
        }
        $('#seo-select-photocenter').removeClass('is-hidden');

        $('.js-set-pointer-seo-city').removeClass('is-active');
        $(this).addClass('is-active');

        var $element = $('.js-set-seo-photocenter');
        $element.children('option').addClass('is-hidden');
        $element.children('option[data-city="' + selectCityId + '"]').removeClass('is-hidden');

        selectPhotocenterId = $element.children('option[data-city="' + selectCityId + '"]').attr('value');
        $element.val(selectPhotocenterId);

        if (selectCityId == '') {
            $('#seo-select-photocenter').addClass('is-hidden');
            return;
        }
        $('#seo-select-photocenter').removeClass('is-hidden');
    });

    $(document).on('change', '.js-set-seo-city', function () {
        selectSeoCityId = $(this).val();
        citySysName = $('.js-set-seo-city').find(':selected').data('sys_name');
    });

    $(document).on('click', '.js-save-seo-form', function (event) {
        selectSeoPhotocenterId = $('.js-set-seo-photocenter').val();
        citySysName = $('.js-set-pointer-seo-city.is-active').data('sys_name');

        if (selectSeoPhotocenterId !== undefined) {
            savePhotocenter(selectSeoPhotocenterId);
            return;
        }

        saveSeoCity();
    });

    $(document).on('click', '.js-save-seo-city', function (event) {
        citySysName = $('.js-set-seo-city').find(':selected').data('sys_name');
        selectSeoCityId = $('.js-set-seo-city').val();

        saveSeoCity();
    });

    $(document).on('click', '.js-save-default-seo-city', function () {
        selectSeoPhotocenterId = $(this).attr('data-id');
        if (selectSeoPhotocenterId !== undefined) {
            window.Request.post('/cookie/address', {addressId: selectSeoPhotocenterId}, function () {
            });
        }
        let isCity = getCookie('saved_seo_city');
        let oldSysName = $(this).attr('data-current-sys-name');

        window.Request.post('/cookie/default-city', function () {
            if (isCity) {
                //удаляем из city из path
                let path = window.location.pathname.replace(oldSysName + '/', '');
                //найти url по умолчанию в правилах
                path = findDefaultUrl(path);
                if (path) {
                    return window.location.replace(path);
                }
                location.reload();
            } else {
                location.reload();
            }
        });
    });

    $(document).on('click', '.js-show-cities', function () {
        var $element = $('.navbar-cities');
        if ($element.hasClass('is-hidden')) {
            $element.removeClass('is-hidden');
        } else {
            $element.addClass('is-hidden');
        }
    });

    function saveSeoCity() {
        let isCity = getCookie('saved_seo_city')

        window.Request.post(
            '/cookie/city',
            {seoCityId: selectSeoCityId},
            function () {
                //если установлен город
                if (isCity) {
                    let oldSysName = $(`.js-set-pointer-seo-city[data-id=${isCity}]`).data('sys_name')
                        || $(`.js-set-seo-city option[value=${isCity}]`).data('sys_name');
                    let path = window.location.pathname.replace(oldSysName, citySysName);
                    location.href = path;
                } else {
                    //если url есть в rules, то к url добавить city и сделать редирект
                    let newPath = findNewUrl(window.location.pathname + location.search);
                    if (newPath) {
                        return window.location.replace(
                            `/${citySysName}${newPath}`
                        );
                    }
                    location.href = location.href;
                }
            }
        );
    }

    function savePhotocenter(id) {
        window.Request.post('/cookie/address', {addressId: id}, function () {
            saveSeoCity();
        });
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    //совпадает ли текущий url с правилом
    function findDefaultUrl(currentPath) {
        for (path in rules) {
            //получение параметров из rules path
            let result = path.match(/\<(.*?)\>/);
            if (result === null) {
                if (path === currentPath) {
                    return rules[path];
                }
                continue;
            }
            //удаление параметров из rules path
            let pathRule = path.replace(`/${result[0]}`, '');

            let sign = '/';
            if (currentPath.includes('?')) {
                sign = '?';
            }
            //удаление параметров из текущего path
            let arrPath = currentPath.split(sign);
            //значение параметра
            let param = arrPath.pop(arrPath.length - 1);
            newCurrentPath = arrPath.join(sign);
            //если совпадает, то вернуть соответствующий адрес
            if (newCurrentPath == pathRule) {
                return rules[path].replace(`${result[0]}`, param);
            }
        }
        return false;
    }

    function findNewUrl(currentPath) {
        for (path in rules) {
            //получение параметров из rules path
            let result = rules[path].match(/\<(.*?)\>/);
            if (result === null) {
                if (rules[path] === currentPath) {
                    return path;
                }
                continue;
            }

            let sign = '/';
            if (currentPath.includes('?')) {
                sign = '=';
            }
            //удаление параметров из rules path
            let pathRule = rules[path].replace(`${result[0]}`, '');
            //удаление параметров из текущего path
            let arrPath = currentPath.split(sign);
            //значение параметра
            let param = arrPath.pop(arrPath.length - 1);
            newCurrentPath = arrPath.join(sign) + sign;

            if (newCurrentPath == pathRule) {
                return path.replace(`${result[0]}`, param);
            }
        }
        return false;
    }
});
